export default {
      id: "notifications__geozone-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__geozone",
      toString: function () {
        return this.url;
      }
    }